import React from 'react';
import classnames from 'classnames';
import { Link } from 'react-router';

import styles from './index.css';

const Button = ({
	children,
	className,
	color,
	link,
	lan,
	type = 'internal',
	disabled = false,
	onClick = () => {},
	...other
}) => {
	if (link) {
		if (type === 'external') {
			return (
				<a
					className={classnames(styles.button, className, {
						[styles.inverse]: color === 'inverse',
						[styles.primary]: color === 'primary',
						[styles.accent]: color === 'accent',
						[styles.disabled]: disabled,
						[styles.noLetterSpacing]: lan === 'en',
					})}
					href={link}
					target="_blank"
					onClick={e => {
						if (!disabled) {
							onClick(e);
						}
					}}
					{...other}
				>
					<div>{children}</div>
				</a>
			);
		}

		return (
			<Link
				className={classnames(styles.button, className, {
					[styles.inverse]: color === 'inverse',
					[styles.primary]: color === 'primary',
					[styles.accent]: color === 'accent',
					[styles.disabled]: disabled,
					[styles.noLetterSpacing]: lan === 'en',
				})}
				to={link}
				onClick={e => {
					if (!disabled) {
						onClick(e);
					}
				}}
				{...other}
			>
				<div>{children}</div>
			</Link>
		);
	}

	return (
		<button
			className={classnames(styles.button, className, {
				[styles.inverse]: color === 'inverse',
				[styles.primary]: color === 'primary',
				[styles.accent]: color === 'accent',
				[styles.disabled]: disabled,
				[styles.noLetterSpacing]: lan === 'en',
			})}
			onClick={e => {
				if (!disabled) {
					onClick(e);
				}
			}}
			{...other}
		>
			<div>{children}</div>
		</button>
	);
};

export default Button;



// WEBPACK FOOTER //
// ./src/components/atoms/Button/component.js